import _ from 'lodash';
import React from 'react';
import TZDate from '../../commons/services/TZDate';
import OpeningHoursContainer
  from '../../commons/components/OpeningHoursContainer';
import SpecialOpeningHoursContainer
  from '../../commons/components/SpecialOpeningHoursContainer';
import DrilldownMenuList from '../../commons/components/DrilldownMenuList';
import withBackButton from '../../commons/components/withBackButton';
import createNavigationContainer
  from '../../commons/components/createNavigationContainer';
import { weekdays } from '../../commons/services/static';
import UI from '../../commons/services/UI';
import { isPremium } from '../../commons/services/Wix';

const MAX_SPECIALS = 10;

function randomId() {
  return Math.random().toString(36).substr(2, 9);
}

const OpeningHoursContainerWithBackButton = withBackButton(
  OpeningHoursContainer
);

function formatTimerangesForSubline(timeranges) {
  return timeranges.map(({ from, to }) => `${from} to ${to}`).join(', ');
}

function formatDatesForSubline(startDate, endDate) {
  // TODO: should we have a special case for when startDate === endDate?
  if (startDate === endDate) {
    return startDate;
  }

  return `From ${startDate} to ${endDate}`;
}

function HoursSettings({ onUpdate, data, styles, addComponentToPath }) {
  const firstIndex = _.findIndex(
    weekdays,
    day => day.value === _.get(styles, 'firstDayOfWeek.value', 'monday')
  );
  const orderedWeekdays = weekdays
    .slice(firstIndex, weekdays.length)
    .concat(weekdays.slice(0, firstIndex));

  const items = orderedWeekdays.map(day => {
    const timeranges = _.get(
      data,
      `openingHoursByDay.${day.value}.openingHours`,
      []
    );

    function edit() {
      addComponentToPath(OpeningHoursContainerWithBackButton, {
        day: day.value
      });
    }

    const subLabel = formatTimerangesForSubline(timeranges);

    return {
      label: day.label,
      subLabel: subLabel || 'No time slots defined',
      onClick: edit,
      menuItems: []
    };
  });

  return <DrilldownMenuList items={items} />;
}

const SpecialOpeningHoursContainerWithBackButton = withBackButton(
  SpecialOpeningHoursContainer
);

function SpecialHoursSettings({ onUpdate, data, addComponentToPath }) {
  function getIdxById(id) {
    return _.findIndex(data.specialOpeningHours, special => special.id === id);
  }

  function getById(id) {
    const idx = getIdxById(id);
    if (_.isNumber(idx)) {
      return data.specialOpeningHours[idx];
    }
  }

  function edit(id) {
    addComponentToPath(SpecialOpeningHoursContainerWithBackButton, {
      id
    });
  }

  function copy(id) {
    const originSpecial = _.cloneDeep(getById(id));

    const newSpecial = {
      ...originSpecial,
      id: randomId()
    };

    onUpdate(data, {
      specialOpeningHours: {
        $push: [newSpecial]
      }
    });
  }

  function del(id) {
    const newSpecialOpeningHours = data.specialOpeningHours.filter(
      special => special.id !== id
    );

    onUpdate(data, {
      specialOpeningHours: {
        $set: newSpecialOpeningHours
      }
    });
  }

  function add() {
    const id = randomId();
    const inOneWeek = new TZDate().addDays(7);

    onUpdate(data, {
      specialOpeningHours: {
        $push: [
          {
            id: id,
            note: '',
            start: inOneWeek.getLocalDateString(),
            end: inOneWeek.getLocalDateString(),
            openingHours: []
          }
        ]
      }
    });
    edit(id);
  }

  const items = data.specialOpeningHours.map((special, idx) => {
    return {
      label: `${idx + 1}. Special Event`,
      subLabel: formatDatesForSubline(special.start, special.end),
      onClick: () => edit(special.id),
      menuItems: [
        {
          label: 'Edit',
          iconSRC: 'assets/images/symbol_edit.svg',
          onClick: ev => {
            ev.stopPropagation();
            edit(special.id);
          }
        },
        {
          label: 'Duplicate',
          iconSRC: 'assets/images/symbol_duplicate.svg',
          onClick: ev => {
            ev.stopPropagation();
            copy(special.id);
          }
        },
        {
          label: 'Delete',
          iconSRC: 'assets/images/symbol_delete.svg',
          onClick: ev => {
            ev.stopPropagation();
            del(special.id);
          }
        }
      ]
    };
  });

  const isAddDisabled = items.length >= MAX_SPECIALS;

  return (
    <div className="SpecialHoursContainer">
      <DrilldownMenuList items={items} />
      <UI.button
        className="btn add"
        onClick={add}
        disabled={isAddDisabled}
        label="Add Special Event"
      />
    </div>
  );
}

function PremiumTeaser({ onUpgradeClick }) {
  return (
    <div className="PremiumTeaserContainer">
      <div className="PremiumTeaserUpgradeSymbol">
        <UI.symbol name="premiumLarge" onClick={onUpgradeClick} />
      </div>
      Upgrade App in order to add special events, like a Happy Hour, to your business hours.
      <UI.button className="btn" label="Add Special Event" disabled />
    </div>
  );
}

function HoursTab(props) {
  return (
    <div className="HoursTab">
      <UI.sectionDividerLabeled
        label="Business Hours"
        infoText="Edit your business hours for each weekday"
      />
      <hr className="divider-long" />
      <div className="OpeningHoursContainer">
        <HoursSettings {...props} />
        <hr className="divider-long" />
      </div>
      <UI.sectionDividerLabeled
        label="Special Events"
        infoText="Overwrite your regular business hours for a specific time period e.g., if you’re going on vacation."
      />
      <hr className="divider-long" />
      {isPremium()
        ? <SpecialHoursSettings {...props} />
        : <PremiumTeaser onUpgradeClick={props.onUpgradeClick} />}
      <div style={{ height: '200px' }} />
    </div>
  );
}
export default createNavigationContainer(HoursTab);



// WEBPACK FOOTER //
// ./src/apps/settings/HoursTab.jsx